import ResponseTemplate from './ResponseTemplate.js'

/**
 * @class
 * @implements ResponseTemplate
 */
export default class EditorialFeedResponseTemplate extends ResponseTemplate {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Faker} deps.faker
   * @param {Object} deps.libs
   */
  constructor({faker} = {}) {
    super({faker})
    this._faker = faker
  }

  getCochesData = field => {
    switch (field) {
      case 'body':
        return {
          items: [
            {id: '0', name: 'Body 1'},
            {id: '1', name: 'Body 2'},
            {id: '2', name: 'Body 3'}
          ]
        }
      case 'color':
        return {
          items: [
            {id: '0', name: 'Color 1'},
            {id: '1', name: 'Color 2'},
            {id: '2', name: 'Color 3'}
          ]
        }
      case 'year':
        return {
          items: [
            {id: '0', name: '2000'},
            {id: '1', name: '2001'},
            {id: '2', name: '2002'}
          ]
        }
      case 'fuel':
        return {
          items: [
            {id: '0', name: 'Diesel'},
            {id: '1', name: 'Gasolina'},
            {id: '2', name: 'Eléctrico'}
          ]
        }
      case 'gearbox':
        return {
          items: [
            {id: '0', name: 'Manual'},
            {id: '1', name: 'Automático'}
          ]
        }
      case 'version':
        return {
          items: [
            {id: '0', name: 'Version 1'},
            {id: '1', name: 'Version 2'},
            {id: '2', name: 'Version 3'}
          ]
        }
      default:
        console.log('Error faking data') // eslint-disable-line no-console
    }
  }

  getMotosData = field => {
    switch (field) {
      case 'body':
        return {
          items: [
            {id: 0, name: 'Motocicletas'},
            {id: 2, name: 'Clásicas y cometiciñon'},
            {id: 3, name: 'Buggy'},
            {id: 4, name: 'Mini motos'}
          ]
        }
      case 'color':
        return {
          items: [
            {id: '0', name: 'Color 1'},
            {id: '1', name: 'Color 2'},
            {id: '2', name: 'Color 3'}
          ]
        }
      case 'year':
        return {
          items: [
            {id: '0', name: '2000'},
            {id: '1', name: '2001'},
            {id: '2', name: '2002'}
          ]
        }
      case 'fuel':
        return {
          items: [
            {id: '0', name: 'Gasolina'},
            {id: '1', name: 'Eléctrica'}
          ]
        }
      case 'gearbox':
        return {
          items: [
            {id: '0', name: 'Manual'},
            {id: '1', name: 'Automática'}
          ]
        }
      case 'version':
        return {
          items: [
            {id: '0', name: 'Version 1'},
            {id: '1', name: 'Version 2'},
            {id: '2', name: 'Version 3'}
          ]
        }
      default:
        console.log('Error faking data') // eslint-disable-line no-console
    }
  }

  /**
   * @method
   * @return {Array<literal: string, model: number>}
   */
  build({url, appName}) {
    const field = url.split('/')[4]
    const response = appName === 'COCHES' ? this.getCochesData(field) : this.getMotosData(field)
    return response
  }
}
